import { render, staticRenderFns } from "./StatInterventions.vue?vue&type=template&id=63adda8a&"
import script from "./StatInterventions.vue?vue&type=script&lang=js&"
export * from "./StatInterventions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports